import React from "react";
import { useStyles } from "./TheyTrustStyle";
import { Box, Button, Typography } from "@mui/material";
import TrustUsCarousel from "./TrustUsCarousel";
import Testimonials from "./TestimonialsContainer";

const TheyTrustUS = () => {
  const classes = useStyles();
  return (
    <Box className={classes.MainContainer} id="they-trust">
      <div data-aos="fade-down">
        <Typography className={classes.Heading}>
          Ils nous <br className={classes.lineBreaker} />{" "}
          <span className={classes.HeadingSpan}>font confiance </span>
        </Typography>
      </div>
      <TrustUsCarousel />
      <Box className={classes.TrustUsBottomBgWrapper}></Box>
    </Box>
  );
};

export default TheyTrustUS;
